import React from 'react'

export const Info = () => {
  return (
    <div className='Info'>
    <div id="carouselExampleIndicators" class="carousel slide">
   <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="6" aria-label="Slide 7"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1684447278/Imagen1_aav3dx.jpg" className="d-block" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1684447768/imagen2_o1vimc.jpg" className="d-block" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1684447771/imagen3_spwtu2.jpg" className="d-block" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685651853/excursion1_4_dtr7vd.jpg" className="d-block" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685651860/excursion1_2_fdfwls.jpg" className="d-block" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685651882/excursion_dmcclq.jpg" className="d-block" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685651767/excursion1_3_tg3h3q.jpg" className="d-block" alt="..."/>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-KK94CHFLLe+nY2dmCWGMq91rCGa5gtU4mk92HdvYe+M/SXH301p5ILy+dN9+nJOZ" crossorigin="anonymous"></link>
<script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.7/dist/umd/popper.min.js" integrity="sha384-zYPOMqeu1DAVkHiLqWBUTcbYfZ8osu1Nd6Z89ify25QV9guujx43ITvfi12/QExE" crossorigin="anonymous"></script>
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/js/bootstrap.min.js" integrity="sha384-Y4oOpwW3duJdCWv5ly8SCFYWqFDsfob/3GkgExXKV4idmbt98QcxXYs9UoXAB7BZ" crossorigin="anonymous"></script>
    </div>
    )
  }
  
  {/* <h2 className='Titulo'>Gran Aventura</h2>
  <p className='descrip'>Tenemos 5 años cumpliéndole a los estudiantes del departamento del Quindío. Ofrecemos una excursión que nunca olvidarán, somo garantía de calidad</p> */}